import axios from 'axios';
import {backendHost} from '../../config';

export const getDashboardVisite = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/dashboard/visite`, {params});
};